import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTicketAlt, faPlus, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Form, Row, Col, Button, Badge, Modal, Alert } from "react-bootstrap";
import CreditCardInput from 'react-credit-card-input';
import { LinkContainer } from "react-router-bootstrap";

import LoaderButton from "components/LoaderButton";
import ShowTickets from "components/shows/ShowTickets";
import ShowMapTickets from "components/shows/ShowMapTickets";
import ShowDates from "components/shows/ShowDates";
import CardGroup from '../common/CardGroup';
import Loader from "components/Loader";

import { useCart } from "libs/cartLib";
import { useAnalytics } from "libs/analytics";
import { useFormFields } from "libs/hooksLib";
import { useAppContext } from "libs/contextLib";
import { renderCountryOptions } from "libs/formsLib";
import { onError, Notification } from "libs/errorLib";
import config from 'config';
import moment from 'moment';

import "./RegistrationForm.css";

export default function RegistrationForm({
    user, sessionId, show, tickets, showMap, showDates, 
    onShowDateChange, selectedShowDate, isLoadingData, onSuccess, onFailure
}) {
    const [selectedTickets, setSelectedTickets] = useState(null)
    const [totalTickets, setTotalTickets] = useState(0)
    const [orderTotal, setOrderTotal] = useState(0)
    const [isLoading, setIsLoading] = useState(false)

    const { trackEvent } = useAnalytics();
    const { getSession } = useAppContext();
    const { getCart, addCartItems, resetCart, createOrder } = useCart();
    
    const [fields, handleFieldChange] = useFormFields({
        saveInfo: true,
        firstname: user?.firstname || "",
        lastname: user?.lastname || "",
        email: user?.email || "",
        emailConfirm: user?.email || "",
        phone: user?.phone || "",
        address: user?.address || "Ciudad",
        city: user?.city || "Guatemala",
        state: user?.state || "Guatemala",
        country: user?.country || "GT",
        zip: user?.zip || "",
        nit: user?.nit || "",
    });

    useEffect(() => {
        // Initialize when component mounts
        if (tickets) {
            setSelectedTickets(tickets)
        }
    }, [tickets])

    async function processPayment(currency, payment_type, payment_info) {
        const session = await getSession()

        const order = {
            user_uid: user?._id,
            payment_type: payment_type,
            currency: currency,
            payment_info: payment_info,                
        }
        const purchase = await createOrder(order)
        return purchase
    }

    function validateForm() {
        return fields.firstname.length > 0 
            && fields.lastname.length > 0
            && fields.email.length > 0
            && fields.email == fields.emailConfirm
            && fields.country.length > 0
            && totalTickets > 0; // Only check for tickets selected, not total price since registration tickets are free
    }

    function handleNotifyTicketChange(tickets, totalTickets, orderTotal, orderDiscountTotal, currency) {
        setSelectedTickets(tickets)
        setTotalTickets(totalTickets)
        setOrderTotal(orderTotal)
    }

    function renderShowTickets() {
        if (selectedShowDate) {
            if (tickets && tickets.length > 0) {
                return selectedShowDate?.settings?.has_map ?
                        showMap ? 
                        <div style={{marginTop:10}}>
                            <ShowMapTickets 
                                show={selectedShowDate} 
                                showTickets={tickets} 
                                showMap={showMap} 
                                paymentType={"REGISTRATION"} 
                                showViewCart={false}  
                            />
                        </div> : <Loader /> 
                    : <ShowTickets 
                        show={selectedShowDate} 
                        tickets={tickets} 
                        showAddToCart={false} 
                        notifyTicketChange={handleNotifyTicketChange}
                        paymentType="REGISTRATION"
                    />
                
            } else {
                return <div style={{paddingTop: 10}}>
                { isLoadingData 
                    ? <Loader />
                    : <Alert variant="warning">No hay tickets disponibles para registro en este evento</Alert> 
                }
                </div>
            }
            
        }
        return <></>
    }

    async function handleSubmit(event) {    
        event.preventDefault();        
        setIsLoading(true);
        trackEvent({
            action: "Clicked Registration Button",
            category: "RegistrationFunnel"
        });
        
        try {
            const currency = 'GTQ'
            const payment_type = 'REGISTRATION'

            const payment_info = {
                firstname: fields.firstname,
                lastname: fields.lastname,
                email: fields.email,
                phone: fields.phone,
                address: fields.address,
                city: fields.city,
                state: fields.state,
                country: fields.country,
                zip: fields.zip,
                nit: fields.nit || "",
                currency: currency,
                total: orderTotal,
                sessionId: Cookie.get('sessionID')
            }

            // Reset cart first
            try {                
                await resetCart()
            } catch(e) {
                console.log('error resetting cart')
            }

            // Add items to cart
            const items = selectedTickets.filter(t => parseInt(t.selected) > 0).map(t => {            
                const date = moment(selectedShowDate.show_date).format('ddd, LL - LT')
                
                const cartItem = {
                    ticket_uid: t._id,
                    code: t.code,
                    type: 'TICKET',
                    show_uid: selectedShowDate._id,
                    show_name: selectedShowDate.fullname,
                    show_date: selectedShowDate.show_date,
                    show_type: selectedShowDate.type,
                    venue: selectedShowDate.venue,
                    title: `${selectedShowDate.fullname} (${date})`,
                    description: t.fullname,
                    note: t.note,
                    ticket_type: t.type,
                    image: `${selectedShowDate.main_image}`,
                    quantity: parseInt(t.selected)
                }

                if (t.bundle && t.bundle.length > 0) {
                    cartItem.bundle_items = t.bundle.map(item => {
                        const it = {
                            ticket_uid: item._id,
                            code: item.code,
                            type: 'TICKET',
                            show_uid: selectedShowDate._id,
                            show_name: selectedShowDate.fullname,
                            show_date: selectedShowDate.show_date,
                            show_type: selectedShowDate.type,                               
                            venue: selectedShowDate.venue,
                            description: item.fullname,
                            note: item.note,
                            ticket_type: item.type,
                            image: `${selectedShowDate.main_image}`,
                            quantity: item.ammount * parseInt(t.selected)
                        }
                        if (item.location) {
                            it.location = item.location
                        }
                        if (item.ticket_image) {
                            it.ticket_image = item.ticket_image
                        }
                        if (item.qr_color) {
                            it.qr_color = item.qr_color
                        }
                        return it
                    })
                }

                if (t.location) {
                    cartItem.location = t.location
                } else {
                    cartItem.location = {}
                }

                return cartItem
            })

            await addCartItems({ payment_type: payment_type, currency: currency, items: items })
            
            // Process payment
            const purchase = await processPayment(currency, payment_type, payment_info)
            
            if (purchase) {
                payment_info.save_info = fields.saveInfo
                // Keep loading state active during redirect to prevent visual reset
                await onSuccess && onSuccess(payment_info, purchase)
                return true
            } else {
                Notification('error', 'No fue posible realizar el registro', null, 'top')
                await onFailure && onFailure(purchase)
                setIsLoading(false);
                return false
            }        
            
        } catch(error) {
            console.log(error, error.response, error.status, error.data, error.errors)
            Notification('error', 'No fue posible realizar el registro', null, 'top')
            setIsLoading(false);
            return false
        }
    }

    function renderForm() {        
        return <div className="registration-form-modern">
            {isLoading && (
                <div className="registration-loading-overlay">
                    <div className="registration-loading-content">
                        <Loader />
                        <div className="registration-loading-text">
                            Procesando tu registro...
                        </div>
                    </div>
                </div>
            )}
            <Form onSubmit={handleSubmit} className="show-form">
                
                <div className="show-tickets">
                    { showDates && <ShowDates show={show} showDates={showDates} onChange={onShowDateChange} /> }                        
                    { renderShowTickets() }
                </div>  

                <div className="show-registration-form">
                { totalTickets > 0 && <>
                     <CardGroup 
                       title="Registro Gratuito"
                       description="Completa tus datos personales para finalizar el registro. Tus boletos serán enviados al correo electrónico."
                     >
                       <div className="registration-container">
                         <div className="registration-info">
                           <div className="registration-details">
                             <h4>Información del Registro</h4>
                             <p>
                               Este es un evento gratuito. Al completar el registro, recibirás tus boletos por correo electrónico.
                             </p>
                           </div>
                         </div>
                       </div>
                     </CardGroup>                  

                     <CardGroup 
                       title="Datos de Registro"
                       description="Verifica los detalles de tu registro antes de proceder. Tus boletos serán enviados al correo registrado."
                     >
                       <Form.Row>
                         <Form.Group as={Col} controlId="saveInfo">                        
                           <Form.Check type="checkbox" label="Guardar los datos en mi perfil" checked={fields.saveInfo} onChange={handleFieldChange} />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="firstname">
                           <Form.Label>Nombre*</Form.Label>
                           <Form.Control 
                             required 
                             placeholder="ej: José"  
                             value={fields.firstname} 
                             onChange={handleFieldChange} 
                             className={fields.firstname == "" ? "field-error" : "field-ok"} 
                           />
                         </Form.Group>

                         <Form.Group as={Col} controlId="lastname">
                           <Form.Label>Apellido*</Form.Label>
                           <Form.Control 
                             placeholder="ej: Pérez"  
                             value={fields.lastname} 
                             onChange={handleFieldChange}  
                             className={fields.lastname == "" ? "field-error" : "field-ok"} 
                           />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="email">
                           <Form.Label>Email*</Form.Label>
                           <Form.Control 
                             type="email" 
                             placeholder="" 
                             value={fields.email} 
                             onChange={handleFieldChange}  
                             className={fields.email == "" ? "field-error" : "field-ok"} 
                           />
                         </Form.Group>

                         <Form.Group as={Col} controlId="emailConfirm">
                           <Form.Label>Confirmar Email*</Form.Label>
                           <Form.Control 
                             type="email" 
                             placeholder="" 
                             value={fields.emailConfirm} 
                             onChange={handleFieldChange}  
                             className={fields.emailConfirm != fields.email ? "field-error" : "field-ok"} 
                           />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="phone">
                           <Form.Label>Teléfono</Form.Label>
                           <Form.Control 
                             placeholder="ej: 502 1234 5678"  
                             value={fields.phone} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>

                         <Form.Group as={Col} controlId="country">
                           <Form.Label>País*</Form.Label>
                           <Form.Control as="select" value={fields.country} onChange={handleFieldChange}>                            
                               {renderCountryOptions()}
                           </Form.Control>
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="address">
                           <Form.Label>Dirección</Form.Label>
                           <Form.Control 
                             placeholder="ej: Zona 1"  
                             value={fields.address} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>

                         <Form.Group as={Col} controlId="city">
                           <Form.Label>Ciudad</Form.Label>
                           <Form.Control 
                             placeholder="ej: Guatemala"  
                             value={fields.city} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="state">
                           <Form.Label>Departamento</Form.Label>
                           <Form.Control 
                             placeholder="ej: Guatemala"  
                             value={fields.state} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>

                         <Form.Group as={Col} controlId="zip">
                           <Form.Label>Código Postal</Form.Label>
                           <Form.Control 
                             placeholder="ej: 01001"  
                             value={fields.zip} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <Form.Group as={Col} controlId="nit">
                           <Form.Label>NIT (Opcional)</Form.Label>
                           <Form.Control 
                             placeholder="ej: 12345678-9"  
                             value={fields.nit} 
                             onChange={handleFieldChange}  
                           />
                         </Form.Group>
                       </Form.Row>

                       <Form.Row>
                         <LoaderButton
                             block
                             type="submit"
                             size="lg"
                             isLoading={isLoading}
                             disabled={!validateForm()}
                             variant={validateForm() ? 'primary' : 'secondary'}
                             className="btn-theme-primary"
                         >
                             Completar Registro
                         </LoaderButton>
                       </Form.Row>
                     </CardGroup>
                </>}
                </div>
            </Form>
        </div>
    }

    return renderForm()
}